import React, {useEffect, useState} from 'react'

const RegistrationConfirmation = ({email, signUp}) => {

    const [timer, setTimer] = useState('5:00');
    const [processing, setProcessing] = useState(false);

    useEffect(() => {
        let interval = null;

        if (timer !== '0:00') {
            interval = setInterval(() => {
                setTimer(prevTime => {
                    const [minutes, seconds] = prevTime.split(':').map(Number);
                    if (seconds === 0) {
                        if (minutes === 0) {
                            clearInterval(interval);
                            return '0:00';
                        }
                        return `${minutes - 1}:59`;
                    }
                    return `${minutes}:${seconds - 1 < 10 ? '0' : ''}${seconds - 1}`;
                });
            }, 1000);
        }

        return () => clearInterval(interval);
    }, [timer]);

    const resendVerificationEmail = async () => {
        setProcessing(true);
        const response = await signUp();
        
        if (response.success) 
            setTimer('5:00'); // Reset timer

        setProcessing(false);
    };

    return (
        <div className='background-grid d-flex flex-column justify-content-center align-items-center landscape-spacing' style={{minHeight: "80vh"}}>
            <div className='d-flex flex-column custom-container'>
                <h2 className='text-center mb-3' style={{fontWeight: 400}}>Verify Your Email</h2>
                <p className='text-center mb-3'>We've sent a verification link to <strong>{email}</strong>.</p>
                <p className='text-center mb-3'>Click the link in the email to verify your account and complete your registration. The email should arrive within a few minutes.</p>
                <p className='text-center mb-3'>If you don't see it, please check your <strong>spam</strong> or <strong>junk</strong> folder.</p>
                <p className='microtext text-center'><strong>Didn't receive it?</strong></p>
                <p className='microtext text-center mb-3'>You can request a new verification link in {timer}</p>
                {timer === '0:00' && (
                    <button className='rounded w-100' style={{backgroundColor: '#FFCC19', height: "45px", fontWeight: 600, marginTop: "10px"}} disabled={processing} onClick={resendVerificationEmail}>Resend Verification Email</button>
                )}
            </div>
        </div>
    )
}

export default RegistrationConfirmation